module.exports = __webpack_public_path__ + "assets/img/img55.5f3791ad.png";